
const config = {
  useStreetCabinetUploadField: true,

  requestMapShowActiveRedMarker: false,

  visibleRequestsByRealisationStatuses: {
    completed: false,
    cancelled: true,
    onhold: true
  },

  // Enable the possibility to reset or cancel already saved date
  canResetDateValue: true
};
export default config;
